import { render, staticRenderFns } from "./shopify-auth.vue?vue&type=template&id=3c2ff836&scoped=true&"
import script from "./shopify-auth.vue?vue&type=script&lang=js&"
export * from "./shopify-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2ff836",
  null
  
)

export default component.exports